module.exports = __webpack_public_path__ + "img/img8.b2fd65c7.svg";